import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Formik } from "formik";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import {
  addPatientFeedback,
  getNewPrescriptionList,
  getPresciptionHistory,
} from "../../actions/prescriptionAction";
import FormikControl from "../../components/WraapperComponent/FormikControl";
import { formatDate } from "../../utils/helper";
const FeedbackPopup = ({ closePopup, previousFeedback, prescriptionId }) => {
  const dispatch = useDispatch();
  const [feedbackContent, setFeedbackContent] = useState(previousFeedback);
  const [showAddSection, setShowAddSection] = useState(false);

  const initialValues = {
    feedback: previousFeedback.feedback,
  };

  const validationSchema = Yup.object({
    feedback: Yup.string().nullable().required("Required"),
  });
  const onSubmit = (values) => {
    const encodedEmail = encodeURIComponent(feedbackContent.practitioner_email);
    dispatch(
      addPatientFeedback(
        feedbackContent.prescriptionId,
        feedbackContent.practitioner_id,
        encodedEmail,
        values.feedback,
        () => {
          closePopup(true);
          dispatch(getNewPrescriptionList());
          dispatch(getPresciptionHistory());
        }
      )
    );
    let newFeedback = feedbackContent;
    newFeedback.feedback = values.feedback;
    newFeedback.date = `${formatDate(new Date())}`;
    setFeedbackContent(newFeedback);
    setShowAddSection(false);
  };
  return (
    <Modal size="xl" show={true}>
      <Modal.Header>
        <div className="modal-title">
          <h5 className="profile-title">Patient Feedback</h5>
          <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
        </div>
      </Modal.Header>
      <Modal.Body>
        <>
          {feedbackContent.feedback ? (
            <>
              {!showAddSection && (
                <p style={{ marginBottom: "0" }}>{feedbackContent.feedback}</p>
              )}
              <div className="d-flex justify-content-end">
                <p className="page-desc">{formatDate(feedbackContent.date)}</p>
              </div>
            </>
          ) : (
            <p className="page-desc">No Feedback</p>
          )}

          {showAddSection ? (
            <div>
              {" "}
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {({ errors, touched }) => {
                  return (
                    <Form>
                      <div className="row">
                        <div className="col-sm-12">
                          <FormikControl
                            control="textarea"
                            label="Feedback: "
                            name="feedback"
                            rows="4"
                            placeholder="Enter Feedback about your prescription here"
                            hasError={errors.feedback && touched.feedback}
                          />
                        </div>
                        <div className="action-btn-wrapper row ml-3">
                          <button
                            className="btn-orange btn-table"
                            type="submit"
                          >
                            {" "}
                            Save
                          </button>
                          <button
                            className="btn-orange btn-table btn-black"
                            onClick={() => setShowAddSection(false)}
                          >
                            {" "}
                            Cancel
                          </button>
                        </div>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          ) : (
            <>
              {feedbackContent.feedback ? (
                <button
                  className="btn-orange btn-table"
                  onClick={() => setShowAddSection(true)}
                >
                  Edit
                </button>
              ) : (
                <button
                  className="btn-orange btn-table"
                  onClick={() => setShowAddSection(true)}
                >
                  Add
                </button>
              )}
            </>
          )}
        </>
      </Modal.Body>
    </Modal>
  );
};
export default FeedbackPopup;
